import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import WorkingOnIt from "../../assets/images/svg-icons-material-io/downloading_FILL0_wght400_GRAD0_opsz48.svg";
import $ from "jquery";

const DownloadProgressModal = () => {
  let navigate = useNavigate();
  const routeDownloadStatus = () => {
    CloseModal();
    let path = "/download-status";
    navigate(path);
  };

  const firstFocusRef = useRef(null);
  useEffect(() => {
    const modalEl = document.getElementById("downloadProgressModal");
    if (!modalEl) return;
    const onShown = () => setTimeout(() => firstFocusRef.current?.focus(), 50);
    modalEl.addEventListener("shown.bs.modal", onShown);
    return () => modalEl.removeEventListener("shown.bs.modal", onShown);
  }, []);

  const CloseModal = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    $("#downloadProgressModal").modal("hide");
  };
  return (
    <div className="Download">
      <div
        className="modal fade"
        id="downloadProgressModal"
        data-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="DownloadProgressTitle"
        aria-describedby="DownloadProgressDesc"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title spacer-inline" id="DownloadProgressTitle">
                Download Progress
              </h3>
              <button
                type="button"
                className="close"
                aria-label="Close Download Progress"
                onClick={CloseModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="ctr">
                <img
                  src={WorkingOnIt}
                  className="w-md1 filter-orange"
                  alt=""
                  aria-hidden="true"
                />
                <div className="field-wrapper sp-margin3">
                  <p id="DownloadProgressDesc">We're working on it...</p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                ref={firstFocusRef}
                aria-label="Go to Download Status page"
                onClick={routeDownloadStatus}
              >
                Download Status
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={CloseModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadProgressModal;
